module.exports = {
	"ha": "nha",
	"id": 5.5,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category and MSM Status, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0c4250"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#0d4440"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#043f61"
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0c4250"
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0d4440"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 30,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#09472e"
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.96969696969697,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#043f61"
					},
					{
						"y": 93.93939393939394,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.93939393939394,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0d4440"
					},
					{
						"y": 87.87878787878788,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 51.515151515151516,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#043f61"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0c4250"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0d4440"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#09472e"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#043f61"
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0d4440"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#09472e"
					},
					{
						"y": 22.727272727272727,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.22222222222221,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#043f61"
					},
					{
						"y": 97.22222222222221,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0c4250"
					},
					{
						"y": 97.22222222222221,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.11111111111111,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#09472e"
					},
					{
						"y": 33.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#043f61"
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.77777777777777,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#0d4440"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#09472e"
					},
					{
						"y": 48.888888888888886,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#043f61"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0d4440"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#043f61"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0c4250"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0d4440"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#09472e"
					},
					{
						"y": 35,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.61702127659575,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#043f61"
					},
					{
						"y": 80.85106382978722,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.72340425531915,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.2127659574468,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#09472e"
					},
					{
						"y": 51.06382978723404,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -62.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.0303030303030276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.379310344827594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -100,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.99999999999999,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -54.54545454545454,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.777777777777779,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.428571428571432,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -61.29032258064516,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.952380952380953,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.860759493670889,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.888888888888886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -100,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.57894736842105,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.076923076923073,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.382978723404253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.636363636363635,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.631578947368418,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.81081081081081,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=2"
			},
			{
				"x": 9,
				"text": "30-39<br>n=10"
			},
			{
				"x": 15,
				"text": "40-49<br>n=7"
			},
			{
				"x": 21,
				"text": ">=50<br>n=33"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=5"
			},
			{
				"x": 34,
				"text": "30-39<br>n=22"
			},
			{
				"x": 40,
				"text": "40-49<br>n=36"
			},
			{
				"x": 46,
				"text": ">=50<br>n=90"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=6"
			},
			{
				"x": 59,
				"text": "30-39<br>n=6"
			},
			{
				"x": 65,
				"text": "40-49<br>n=20"
			},
			{
				"x": 71,
				"text": ">=50<br>n=47"
			}
		],
		"dataTable": {
			"MSM:<30": [
				2,
				2,
				2,
				1,
				1,
				1
			],
			"MSM:30-39": [
				10,
				10,
				9,
				9,
				8,
				3
			],
			"MSM:40-49": [
				7,
				7,
				7,
				7,
				6,
				3
			],
			"MSM:>=50": [
				33,
				32,
				31,
				31,
				29,
				17
			],
			"Non-MSM:<30": [
				5,
				5,
				2,
				2,
				0,
				0
			],
			"Non-MSM:30-39": [
				22,
				22,
				20,
				20,
				11,
				5
			],
			"Non-MSM:40-49": [
				36,
				35,
				35,
				35,
				31,
				12
			],
			"Non-MSM:>=50": [
				90,
				90,
				84,
				79,
				72,
				44
			],
			"Unknown:<30": [
				6,
				3,
				3,
				3,
				3,
				3
			],
			"Unknown:30-39": [
				6,
				6,
				6,
				5,
				4,
				0
			],
			"Unknown:40-49": [
				20,
				19,
				13,
				13,
				10,
				7
			],
			"Unknown:>=50": [
				47,
				44,
				38,
				37,
				33,
				24
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_5.json
// module id = 272
// module chunks = 0